export default __webpack_public_path__ + "static/media/IMAGEM_DOS_PRODUTOS_-_XIAOMI__1_-removebg-preview.4c0d94ac.png";